// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"i9-z"};